import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("hr", { class: "w-14/20" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", { class: "w-14/20" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_SectionPartnerCriteria = _resolveComponent("SectionPartnerCriteria")!
  const _component_SectionCashbackRules = _resolveComponent("SectionCashbackRules")!
  const _component_SectionTiersCalculation = _resolveComponent("SectionTiersCalculation")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: "Buat Konfigurasi Cashback",
    "vertical-separator": false,
    fullPage: "",
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[1] || (_cache[1] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage
  }, {
    "top-right": _withCtx(() => [
      _createVNode(_component_LpButton, {
        customClass: "px-12 py-2.5",
        fontWeight: "semibold",
        title: "Simpan",
        textColor: "white",
        onClick: _ctx.onSubmit,
        disabled: !_ctx.isFormValid
      }, null, 8, ["onClick", "disabled"])
    ]),
    data: _withCtx(() => [
      _createVNode(_component_SectionPartnerCriteria),
      _hoisted_1,
      _createVNode(_component_SectionCashbackRules),
      _hoisted_2,
      _createVNode(_component_SectionTiersCalculation)
    ]),
    _: 1
  }, 8, ["onBack", "leave-page-confirmation", "onLeavePage"]))
}